// extracted by mini-css-extract-plugin
export var linkText = "_my-0";